import { motion } from 'framer-motion'
import React, { useEffect } from 'react'
// import { MotionScene, MotionScreen, SharedElement } from 'react-motion-layout'
// import aboutPic from '../assets/graphic.webp'
// import aboutPic from '../assets/graphic-1.jpg'
// import me from '../assets/icon-min.png'
import Data from '../data.json'

export default function AboutFull() {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    return (
        <div id="about-full">
            <div className="header">
                {/* <MotionScreen className="header-pic">
                    <MotionScene name="about-pic">
                        <SharedElement.Image
                            className="about-full-pic"
                            alt="graphic"
                            duration=".8"
                            src={aboutPic}
                            animationKey="image"
                        />
                    </MotionScene>
                </MotionScreen> */}
                <motion.div
                    initial={{ y: '50vh', scale: .4 }}
                    animate={{ y: '0', scale: 1 }}
                    transition={{ ease: "easeOut", duration: .4, }}
                    className="header-pic"></motion.div>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ ease: "linear", duration: .6, delay: .3 }}
                    className="header-content">
                    <div id="top-line"></div>
                    <motion.h1
                        initial={{ x: '-100vh', opacity: 0 }}
                        animate={{ x: '0', opacity: 1 }}
                        transition={{ ease: "easeOut", duration: .6 }}
                    >ABOUT ME</motion.h1>
                    <motion.p
                        initial={{ x: '100vh', opacity: 0 }}
                        animate={{ x: '0', opacity: 1 }}
                        transition={{ ease: "easeOut", duration: .7 }}
                    >{Data.profile.about}</motion.p>
                    <div></div>
                </motion.div>
                <div className="scroll-down">SCROLLDOWN <span className="fa fa-long-arrow-down"></span> </div>
            </div>
            <div className="me">
                <div className="me-img-shadow" />
                <div className="me-img" />
            </div>
            <div className="about-full-content row">
                <div className="ed col-md-6">
                    <h4>Education</h4>
                    <div className="ed-under"></div>
                    {
                        Data.education.map((item, id) => (
                            <div key={id} className="education">
                                <h3><a href={item.link} target="_blank" rel="noopener noreferrer">{item.name}</a></h3>
                                <p>{item.sub}  <span>{item.from} - {item.to}</span></p>
                            </div>
                        ))
                    }
                </div>
                <div className="ed col-md-6">
                    <h4>Experience</h4>
                    <div className="ed-under"></div>
                    {
                        Data.experience.map((item, id) => (
                            <div key={id} className="education">
                                <h3>{item.position}</h3>
                                <a href={item.link} target="_blank" rel="noopener noreferrer" ><p>{item.companyname} <span className="fa fa-long-arrow-right a-icon"></span></p></a>
                                <a href={item.lor} target="_blank" rel="noopener noreferrer" ><p>Reference<span className="fa fa-book a-icon"></span></p></a>
                            </div>
                        ))
                    }
                </div>
                <div className="ed col-md-6">
                    <h4>Interests</h4>
                    <div className="ed-under"></div>
                    {
                        Data.interests.map((item, id) => (
                            <div key={id} className="education">
                                {/* <h3>{item.position}</h3> */}
                                <h3>{item.interest}</h3>
                            </div>
                        ))
                    }
                </div>
                <div className="ed col-md-12">
                    <h4>Skills</h4>
                    <div className="ed-under"></div>
                    <div className="row">
                        <div className="col-md-4">
                            <h5>Languages</h5>
                            {
                                Data.skills.Languages.map((item, id) => (
                                    <div key={id} className="education">
                                        <p className="skill-map">{item.lang}</p>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="col-md-4">
                            <h5>FrameWorks</h5>
                            {
                                Data.skills.FrameWorks.map((item, id) => (
                                    <div key={id} className="education">
                                        <p className="skill-map">{item.frame}</p>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="col-md-4">
                            <h5>Tools</h5>
                            {
                                Data.skills.Tools.map((item, id) => (
                                    <div key={id} className="education">
                                        <p className="skill-map">{item.tool}</p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer">
                <a href="mailto:nithins674@gmail.com">nithins674@gmail.com</a>
            </div>
        </div>
    )
}
